import React, { useState } from 'react';
import { Table, TablePaginationConfig } from 'antd';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { PlayerProfileType } from '../../../types/coachProfile';
import { PLAYER_COACH } from '../../../constants/define/translation';
import { ActionsColumn, IndexColumn, TitleColumn } from './columns';
import { appStyles } from '../../../styles';

interface PlayerProfileTableProps {
  records: PlayerProfileType[];
  onRefresh: () => void;
  setIsOpenModal?: Function;
  setDataRecord?: Function;
  handleChangePageActive: Function;
  loading?: boolean;
  className?: string;
  isDraft?: boolean;
  pagination?: TablePaginationConfig;
}

const { Column } = Table;

export const PlayerProfileTable = (props: PlayerProfileTableProps) => {
  const { t } = useTranslation(PLAYER_COACH);
  const [isLoading, setIsLoading] = useState(false);
  const { pagination, records, loading, className } = props;
  const setLoading = (value: boolean) => {
    setIsLoading(value);
  };
  const components: any = {
    body: {},
  };

  return (
    <>
      <DndProvider backend={HTML5Backend}>
        <StyledTable
          dataSource={records}
          loading={loading || isLoading}
          className={className}
          rowKey="index"
          pagination={pagination}
          components={components}
          summary={() => {
            return (
              <>
                <Table.Summary.Row>
                  <Table.Summary.Cell colSpan={2} index={0}>
                    Total: {pagination?.total}
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              </>
            );
          }}
          onRow={(recordDeep: any, index?: number): any => {
            return {
              index,
            };
          }}
        >
          <Column
            title={t('table.title.index')}
            align="center"
            width={32}
            dataIndex="index"
            key="index"
            render={value => <IndexColumn value={value} />}
          />
          <Column
            title={t('table.title.titlePlayer')}
            align="center"
            width={80}
            dataIndex="title"
            key="title"
            render={(_, record: PlayerProfileType) => <TitleColumn record={record} />}
          />
          <Column
            title={t('table.title.action')}
            align="center"
            key="action"
            width={100}
            render={(_, record: PlayerProfileType) => (
              <ActionsColumn record={record} setLoading={setLoading} {...props} />
            )}
          />
        </StyledTable>
      </DndProvider>
    </>
  );
};

const StyledTable = styled(Table)`
  .ant-table-thead {
    border-bottom: 2px solid #eee;
    & > th > tr {
      ${appStyles.background.tableBgGray}
      text-transform: uppercase;
      font-size: 0.75rem;
      font-weight: 600;
      border: 1px solid #dededee3;
      &:before {
        display: none;
      }
    }
  }

  .card-name-tiles {
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  & th.action-home {
    text-align: center !important;
  }
`;
